<div class="flex-col h-100">
    <ui-header-with-breadcrumbs [selectBreadcrumbs]="breadcrumbsSig()"></ui-header-with-breadcrumbs>

    <div class="ui-tab w-100 h-100 flex-col gap-16">
        <div class="flex-row start-start gap-8 visualization-selector">
            <mat-icon svgIcon="table"
                      [class.selected]="visualisationTypeParam() === visualisationTypes.TABLE"
                      (click)="visualisationTypeParam.set(visualisationTypes.TABLE)"
                      [matTooltip]="'FLOW_CHART.RUN_STEPS_VISUALISATION.TABLE'|translate">
            </mat-icon>
            <span class="ui-icon-stacked-chart"
                  [class.selected]="visualisationTypeParam() === visualisationTypes.BAR_CHART"
                  (click)="visualisationTypeParam.set(visualisationTypes.BAR_CHART)"
                  [matTooltip]="'FLOW_CHART.RUN_STEPS_VISUALISATION.BAR_CHART'|translate">
            </span>
            <span class="ui-icon-line-chart"
                  [class.selected]="visualisationTypeParam() === visualisationTypes.LINE_CHART"
                  (click)="visualisationTypeParam.set(visualisationTypes.LINE_CHART)"
                  [matTooltip]="'FLOW_CHART.RUN_STEPS_VISUALISATION.LINE_CHART'|translate">
            </span>
        </div>

        <div class="h-100 min-h-0">
            @switch(visualisationTypeParam()) {
            @case(visualisationTypes.TABLE) {
            <run-steps-table [graphId]="graphIdSig()"
                             [orgId]="orgIdSig()"
                             [runId]="runIdSig()">
            </run-steps-table>
            }

            @case(visualisationTypes.BAR_CHART) {
            <run-steps-chart [graphId]="graphIdSig()"
                             [orgId]="orgIdSig()"
                             [runId]="runIdSig()">
            </run-steps-chart>
            }

            @case(visualisationTypes.LINE_CHART){
            <run-steps-chart [graphId]="graphIdSig()"
                             [orgId]="orgIdSig()"
                             [runId]="runIdSig()"
                             [chartConfig]="{
                                    type: 'line',
                                    dataParseKey: 'startDates',
                                }">
            </run-steps-chart>
            }
            }
        </div>
    </div>
</div>